import { apiClient, type ApiOpts } from './client';

// ── Wire types (snake_case, matching Jackson SNAKE_CASE global config) ─

export type WorkbenchTemplate = {
  template_id: string;
  name: string;
  surface: string;
  originating_prompt: string | null;
  /** Arbitrary JSON — the panel's saved config (payload shape). */
  config: unknown;
  created_at: string;
  updated_at: string;
};

export type SaveTemplateRequest = {
  name: string;
  surface: string;
  originating_prompt?: string | null;
  config: unknown;
};

export type UpdateTemplateRequest = {
  name: string;
  config: unknown;
};

// ── API functions ───────────────────────────────────────────────────────

const BASE = '/api/v1/workbench/templates';

export const workbenchTemplatesApi = {
  list: (surface?: string, opts?: ApiOpts): Promise<WorkbenchTemplate[]> => {
    const qs = surface ? `?surface=${encodeURIComponent(surface)}` : '';
    return apiClient.get<WorkbenchTemplate[]>(`${BASE}${qs}`, opts);
  },

  get: (id: string, opts?: ApiOpts): Promise<WorkbenchTemplate> =>
    apiClient.get<WorkbenchTemplate>(`${BASE}/${encodeURIComponent(id)}`, opts),

  save: (
    req: SaveTemplateRequest,
    opts?: ApiOpts,
  ): Promise<WorkbenchTemplate> =>
    apiClient.post<WorkbenchTemplate>(BASE, req, opts),

  update: (
    id: string,
    req: UpdateTemplateRequest,
    opts?: ApiOpts,
  ): Promise<WorkbenchTemplate> =>
    apiClient.put<WorkbenchTemplate>(
      `${BASE}/${encodeURIComponent(id)}`,
      req,
      opts,
    ),

  delete: (id: string, opts?: ApiOpts): Promise<void> =>
    apiClient.delete<void>(`${BASE}/${encodeURIComponent(id)}`, opts),
};
